import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { FULFILLMENT_KEY } from "./use-fulfillment";

/**
 * POST /v1/orders/{id}/fetch-awb — clears the order's awb-fetch retry state
 * so the scheduler's next tick tries again. Used by the Stuck table's
 * "Retry AWB" row action. On success, re-fetches the fulfillment snapshot so
 * the row's attempt count / stuck set reflect the retry.
 */
export function useRetryAwb() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { data, error } = await apiClient.POST("/v1/orders/{id}/fetch-awb", {
        params: { path: { id } },
      });
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: FULFILLMENT_KEY });
    },
  });
}
